<template>
  <span v-if="isScreen" class="btn" v-bind="$attrs">
    <slot> </slot>
  </span>
  <span v-else class="btn" @click.stop="openDialog" v-bind="$attrs">
    <slot>
      <button>{{ $t('选择部门') }}</button>
    </slot>
  </span>
  <jw-modal :popup-container="popup" titleAlign="start" :title="title || $t('请选择')" class="dialog-pop" :style="props.zIndex > 0 ? { zIndex: props.zIndex } : ''" unmount-on-close v-model:visible="memberDialog" @close="cancelDialog" width="700px">
    <template v-if="leaveStatus == 1" #title>
      <jw-radio-group style="margin-top: 10px" v-model="leaveJob.leaveJobType" :default-value="true">
        <jw-radio :value="1">在职用户</jw-radio>
        <jw-radio :value="0">离职用户</jw-radio>
      </jw-radio-group>
    </template>
    <xl-tree-org :popup="popup" :multipleDep="multipleDep" :memberNumber="memberNumber" :tree="groupTree" v-model:leaveJob="leaveJob" v-model:checkDepartList="departList" v-model:checkUserList="userList" :disabledIds="disabledIds" ref="memberSelect" @cb="getSelected" />
    <template #footer>
      <div class="dialog-footer">
        <div>
          <jw-checkbox v-model="isAllCheckout" v-if="isAllCheckoutShow && leaveJob.leaveJobType" @change="change">全选</jw-checkbox>
        </div>

        <div>
          <jw-button @click="cancelDialog">{{ $t('取消') }}</jw-button>
          <jw-button type="primary" @click="submitData">{{ $t('确定') }}</jw-button>
        </div>
      </div>
    </template>
  </jw-modal>
</template>

<script setup>
import { orgService } from '@/api';
import { useI18n } from 'vue-i18n';
import { computed, reactive, ref, nextTick, watch } from 'vue';
const { t } = useI18n();
const memberDialog = ref(false);
const departList = ref([]);
const userList = ref([]);
const memberSelect = ref(); //组织架构弹窗
const departTreeData = ref([]); // tree 数据
const isAllCheckout = ref(); //是否全选
const isAllCheckoutShow = ref(); //是否显示全选
const leaveJob = reactive({
  // 1 在职 0 离职
  leaveJobType: 1
});
const departDefTree = reactive({
  checkDepartment: false, //false：不能选部门 true：能选部门
  checkUser: true, //false：不能选人员 true：能选人员
  isAll: false, //是否加载全部数据
  userSelector: true, //不传默认时true，角色权限，人员筛选时候传false
  data: [], // 数组 必传
  breadcrumb: t('组织架构'), // 默认 可以不传
  props: {
    label: 'departmentName', // 默认label
    countKey: 'memberCount',
    children: 'children', // data的默认字tree 默认children
    id: 'id', // 必填
    text: t('部门'), // 默认 部门
    defaultAvator: ''
  },
  userProps: {
    label: 'userName',
    id: 'id',
    text: t('用户'),
    avator: 'avatarOrigin',
    defaultAvator: ''
  },
  searchPlaceholder: t('输入关键字进行过滤') // 有这个，则表示有搜索，搜索api的参数 默认为 search
});
const props = defineProps({
  popup: {
    type: String,
    default: 'body'
  },
  title: {
    //modal标题
    type: String
  },
  disabled: {
    //是否禁用
    type: Boolean,
    default: false
  },
  memberNumber: {
    //可选人数数量 0:不限制
    type: Number,
    default: 0
  },
  multipleDep: {
    //true：多选 false: 单选
    type: Boolean,
    default: true
  },
  // 1开启离职人员  0关闭离职人员
  leaveStatus: {
    type: Number,
    default: 0
  },
  tree: {
    //组织架构树
    require: true,
    type: Object,
    default: () => {
      return {
        data: []
      };
    }
  },
  depart: {
    //默认部门
    type: Array,
    default: () => {
      return [];
    }
  },
  user: {
    //默认人员
    type: Array,
    default: () => {
      return [];
    }
  },
  disabledIds: {
    //需要禁用的数据id
    type: Array,
    default: () => {
      return [];
    }
  },
  // 输入框搜索
  isScreen: {
    //需要禁用的数据id
    type: Boolean,
    default: false
  },
  zIndex: {
    //modal的层级
    type: Number,
    default: 0
  }
});
// 打开弹窗
const openDialog = async () => {
  if (props.disabled) {
    return false;
  }
  memberDialog.value = true;
  departList.value = props.depart;
  userList.value = props.user;
  isAllCheckoutShow.value = props.multipleDep && props.tree.checkDepartment;
  getDepartmentTree();
};
defineExpose({ openDialog });
const emits = defineEmits(['cb', 'cancel']);
const groupTree = computed(() => {
  //架构数据
  return Object.assign({}, { ...departDefTree }, { ...props.tree }, { data: departTreeData.value });
});
// 获取组织tree
const getDepartmentTree = () => {
  const params = {
    all: groupTree.value.isAll || false,
    userSelector: groupTree.value.userSelector
  };

  orgService
    .getDepartTreeList(params)
    .then((res) => {
      departTreeData.value = [];
      if (res) {
        const list = res.result || [];
        departTreeData.value = list;
        isAllCheckout.value = checkIdsInObjects(departTreeData.value, departList.value);
        nextTick(() => {
          memberSelect.value?.currentDepartmentArr();
        });
      }
    })
    .catch(() => {});
};
// 确定
const submitData = () => {
  memberDialog.value = false;
  isAllCheckout.value = false;
  const dp = groupTree.value.props;
  const dup = groupTree.value.userProps;
  const d = departList.value.map((el) => {
    const tmp = {};
    tmp[dp.id] = el[dp.id];
    tmp[dp.label] = el[dp.label];
    return tmp;
  });
  const du = userList.value.map((el) => {
    const tmp = {};
    tmp[dup.avator] = el[dup.avator];
    tmp[dup.id] = el[dup.id];
    tmp[dup.label] = el[dup.label];
    return tmp;
  });
  emits('cb', { departList: d, userList: du });
};
const checkIdsInObjects = (objArray, idsArray) => {
  return idsArray.length > 0 && objArray?.every((item) => idsArray?.some((idItem) => idItem.id === item.id));
};

const change = (check) => {
  if (check) {
    departList.value = departTreeData.value;
  } else {
    departList.value = [];
  }
};
watch(
  () => departList.value,
  (v) => {
    isAllCheckout.value = checkIdsInObjects(departTreeData.value, v);
  }
);
// 监听删除事件
const getSelected = (list) => {
  if (list) {
    if (props.multipleDep && props.tree.checkDepartment) {
      isAllCheckoutShow.value = true;
    }

    isAllCheckout.value = checkIdsInObjects(departTreeData.value, list);
  } else {
    isAllCheckoutShow.value = false;
  }
};
// 取消
const cancelDialog = () => {
  memberDialog.value = false;
  isAllCheckout.value = false;
  emits('cancel');
};
</script>
<style scoped lang="less">
.btn {
  cursor: pointer;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;

  .arco-btn {
    margin: 0 10px 0 0;
  }
}
</style>
